var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbahArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 13,
    viewBox: "0 0 5 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16178 0.726757C0.894329 0.422496 0.46263 0.424707 0.197554 0.731695C-0.0675222 1.03868 -0.0655961 1.5342 0.201856 1.83846L1.80455 3.66174C2.455 4.40171 2.90119 4.91097 3.2031 5.34247C3.49637 5.76164 3.59698 6.03087 3.62375 6.272C3.64057 6.4234 3.64057 6.5766 3.62375 6.728C3.59698 6.96913 3.49637 7.23836 3.2031 7.65752C2.90119 8.08903 2.455 8.59829 1.80456 9.33826L0.201856 11.1615C-0.0655961 11.4658 -0.0675222 11.9613 0.197554 12.2683C0.46263 12.5753 0.894329 12.5775 1.16178 12.2732L2.79336 10.4171C3.40787 9.71805 3.91013 9.14669 4.26631 8.63761C4.6367 8.10822 4.90482 7.5709 4.97645 6.92591C5.00785 6.6431 5.00785 6.3569 4.97645 6.07409C4.90482 5.4291 4.6367 4.89177 4.26631 4.36239C3.91012 3.85331 3.40788 3.28196 2.79335 2.58288L1.16178 0.726757Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbahArrow);
export default __webpack_public_path__ + "static/media/ubahArrow.b367e150fcb6e89ef7f06ba00e71f3b1.svg";
export { ForwardRef as ReactComponent };